module.exports = __webpack_public_path__ + "static/media/white@3x.ddb12dc1.png";